import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import Home from './routes/home'
import Builds from './routes/builds'
import LaunchControl from './routes/launch-control'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Router>
    <App>
      <Route exact path="/" component={Home} />
      <Route path="/builds" component={Builds} />
      <Route path="/launch-control" component={LaunchControl} />
    </App>
  </Router>, 
document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js